package com.merkost.handpass.api.dto.site

import kotlinx.serialization.Serializable

@Serializable
data class SuburbOption(
    val name: String,
    val city: String? = null,
    val state: String,
    val postcode: String? = null,
    val latitude: Double,
    val longitude: Double,
    val countryCode: String = "AU",
)
